import { render, staticRenderFns } from "./HomeSummaryCards.vue?vue&type=template&id=61353a65&scoped=true"
import script from "./HomeSummaryCards.vue?vue&type=script&lang=js"
export * from "./HomeSummaryCards.vue?vue&type=script&lang=js"
import style0 from "./HomeSummaryCards.vue?vue&type=style&index=0&id=61353a65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61353a65",
  null
  
)

export default component.exports